"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_TYPE = void 0;
// lega
exports.BUILD_TYPE = {
    REACT_WITH_INTEGRATED_SETTINGS: 'REACT_WITH_INTEGRATED_SETTINGS',
    REACT_WITH_SETTINGS_FILE: 'REACT_WITH_SETTINGS_FILE',
    REACT_WITH_GATSBY: 'REACT_WITH_GATSBY'
};
//# sourceMappingURL=buildType.js.map